// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class Attestation {
    static getAttributeTypeMap() {
        return Attestation.attributeTypeMap;
    }
}
Attestation.discriminator = undefined;
Attestation.additionalProperties = false;
Attestation.attributeTypeMap = [
    {
        "name": "attestationAttributeCode",
        "baseName": "attestationAttributeCode",
        "type": "string"
    },
];
//# sourceMappingURL=attestation.js.map